import * as actions from "./actionsTypes";

const initialData = {
  loaderCountryUser: false,
  countryUser: null,
  countryUserFail: null,
  saveLoaderCountryUser: false,
  countryUserFormError: null,
};

export default function CountryUserReducer(state = initialData, action) {
  // if(action.type ==="GET_COUNTRIESUSER"){
  //   console.log("action.payload")
  //   console.log(action.payload.data)
  //   console.log("action.type")
  //   console.log(action.type)
  // }
  
  switch (action.type) {
    case actions.LOADER_COUNTRIESUSER:
      return { ...state, loaderCountryUser: action.payload };

    case actions.GET_COUNTRIESUSER:
      return { ...state, countryUser: action.payload };

    case actions.COUNTRIESUSER_FAIL:
      return { ...state, countryUserFail: action.payload };

    case actions.SAVE_LOADER_COUNTRIESUSER:
      return { ...state, saveLoaderCountryUser: action.payload };

    case actions.FORM_COUNTRIESUSER_FAIL:
      return { ...state, countryUserFormError: action.payload };

    default:
      return state;
  }
}
